module.exports = __webpack_public_path__ + "img/form.de127865.svg";